import { ImageNone, mergeStyles, VerticalCardExtended } from '@cian/components';
import { shortenNumber } from '@cian/utils/lib/shared/shorten_number';
import * as React from 'react';

import { ISimilarNewobjectsData } from '../../../filters/api/index';

const style = require('./index.css');

const getShortenNumber = (num: number) => {
  let formattedPrice = shortenNumber(num);
  // tslint:disable-next-line:no-any
  formattedPrice = (formattedPrice as any).replace(/\d+(.)\d+/, (t: any) => t.replace('.', ','));

  return `${formattedPrice} руб.`;
};

export interface INewobjectsProps {
  similarNewobjects: ISimilarNewobjectsData[];
  aggregatedOffers: number;
  fromDeveloper?: boolean;
}

const MAX_SIMILAR_OBJECTS_IN_ROW = 4;

function getNewobjectCard(newobject: ISimilarNewobjectsData): React.ReactNode {
  return (
    <a key={newobject.name} href={newobject.fullUrl} target="_blank" className={style['newobjectcard']}>
      <VerticalCardExtended
        customFooterStyles={
          mergeStyles(
            style['card-footer'],
            !newobject.buildersDisplay && style['card-footer--noborder'],
            // tslint:disable-next-line: no-any
          ) as any
        }
        media={
          newobject.imageUrl ? (
            <div
              className={style['newobjectcard-img']}
              style={{
                backgroundImage: `url(${newobject.imageUrl})`,
              }}
            />
          ) : (
            <ImageNone containerStyle={style['noImage']} />
          )
        }
        content={
          <div className={style['newobjectcard-content']}>
            <div className={style['newobjectcard-title']}>
              <span className={style['newobjectcard-jk']}>ЖК «{newobject.name}» </span>
              <span className={style['newobjectcard-status']}>{newobject.statusDisplay}</span>
            </div>

            {newobject.minPrice && (
              <div className={style['newobjectcard-price']}>{`от ${getShortenNumber(newobject.minPrice)}`}</div>
            )}

            {newobject.undergroundInfo && (
              <div className={style['underground']}>
                {newobject.undergroundInfo.lineColor && (
                  <div
                    className={style['underground-pin']}
                    style={{
                      backgroundColor: `#${newobject.undergroundInfo.lineColor}`,
                    }}
                  />
                )}
                {newobject.undergroundInfo.name && (
                  <div className={style['underground-name']}>{newobject.undergroundInfo.name}</div>
                )}
                {newobject.undergroundInfo.timeDisplay && (
                  <div className={style['underground-time']}>{newobject.undergroundInfo.timeDisplay}</div>
                )}
              </div>
            )}

            {!newobject.undergroundInfo && <div className={style['address']}>{newobject.addressDisplay}</div>}
          </div>
        }
        footer={
          <div className={style['newobjectcard-footer']}>
            <div className={style['footer']}>{newobject.buildersDisplay}</div>
          </div>
        }
      />
    </a>
  );
}

export const Newobjects: React.StatelessComponent<INewobjectsProps> = props =>
  // tslint:disable-next-line:no-any
  props.similarNewobjects && (props.similarNewobjects as any).length ? (
    <div className={style['wrapper']}>
      <div className={style['title']}>{props.fromDeveloper ? 'ЖК от застройщика' : 'Похожие ЖК'}</div>
      <div className={style['newobjectcardGroup']}>
        {/* tslint:disable-next-line:no-any */}
        {(props.similarNewobjects as any).slice(0, MAX_SIMILAR_OBJECTS_IN_ROW).map(getNewobjectCard)}
      </div>
    </div>
  ) : (
    // tslint:disable-next-line:no-any
    (null as any)
  );
